package org.moxultimate.topwithmox.showscrud.main

import org.moxultimate.topwithmox.shows.data.ShowsResponse

/**
 * ShowsCRUDState
 * Operation state for create, update, and delete actions in the shows CRUD flow.
 */
sealed class ShowsCRUDState {
    data object Idle    : ShowsCRUDState()
    data object Loading : ShowsCRUDState()
    data class Success(val message: String) : ShowsCRUDState()
    data class Error(val message: String, val statusCode: Int = 0) : ShowsCRUDState()
}

/**
 * ShowsListState
 * Paginated list state for the shows CRUD management page.
 */
sealed class ShowsListState {
    data object Loading : ShowsListState()
    data class Success(val shows: List<ShowsResponse>, val hasMore: Boolean = true) : ShowsListState()
    data class Error(val message: String, val statusCode: Int = 0) : ShowsListState()
}
